import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_3 = { class: "card card-body border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSearch = _resolveComponent("BaseSearch")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_BaseSearch)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        header: _ctx.header,
        data: _ctx.tableData
      }, null, 8, ["header", "data"])
    ]),
    _createVNode(_component_Pagination)
  ]))
}